module.exports = __webpack_public_path__ + "static/media/alert_partner_gold_x2_new.0191d6dd.png";